import { Component, OnInit } from '@angular/core';
import { CustomizerSettingsService } from '../../../components/customizer-settings/customizer-settings.service';
import { StorageService } from '../../../shared/services/storage.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  public environment = environment;
  constructor(
    public themeService: CustomizerSettingsService,
    private storageService: StorageService,
  ) {}

  ngOnInit(): void {
    this.storageService.clear();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  toggleCardBorderTheme() {
    this.themeService.toggleCardBorderTheme();
  }

  toggleCardBorderRadiusTheme() {
    this.themeService.toggleCardBorderRadiusTheme();
  }
}
